export default [
  {
    "code": "AED",
    "currency": "UAE Dirham",
    "decimals": 2
  },
  {
    "code": "ALL",
    "currency": "Albanian Lek",
    "decimals": 2
  },
  {
    "code": "AMD",
    "currency": "Armenian Dram",
    "decimals": 2
  },
  {
    "code": "ANG",
    "currency": "Antillian Guilder",
    "decimals": 2
  },
  {
    "code": "AOA",
    "currency": "Angolan Kwanza",
    "decimals": 2
  },
  {
    "code": "ARS",
    "currency": "Nuevo Argentine Peso",
    "decimals": 2
  },
  {
    "code": "AUD",
    "currency": "Australian Dollar",
    "decimals": 2
  },
  {
    "code": "AWG",
    "currency": "Aruban Guilder",
    "decimals": 2
  },
  {
    "code": "AZN",
    "currency": "Azerbaijani manat",
    "decimals": 2
  },
  {
    "code": "BAM",
    "currency": "Bosnia and Herzegovina Convertible Marks",
    "decimals": 2
  },
  {
    "code": "BBD",
    "currency": "Barbados Dollar",
    "decimals": 2
  },
  {
    "code": "BDT",
    "currency": "Bangladesh Taka",
    "decimals": 2
  },
  {
    "code": "BGN",
    "currency": "New Bulgarian Lev",
    "decimals": 2
  },
  {
    "code": "BHD",
    "currency": "Bahraini Dinar",
    "decimals": 3
  },
  {
    "code": "BMD",
    "currency": "Bermudian Dollar",
    "decimals": 2
  },
  {
    "code": "BND",
    "currency": "Brunei Dollar",
    "decimals": 2
  },
  {
    "code": "BOB",
    "currency": "Bolivia Boliviano",
    "decimals": 2
  },
  {
    "code": "BRL",
    "currency": "Brazilian Real",
    "decimals": 2
  },
  {
    "code": "BSD",
    "currency": "Bahamian Dollar",
    "decimals": 2
  },
  {
    "code": "BWP",
    "currency": "Botswana Pula",
    "decimals": 2
  },
  {
    "code": "BYN",
    "currency": "New Belarusian Ruble",
    "decimals": 2
  },
  {
    "code": "BZD",
    "currency": "Belize Dollar",
    "decimals": 2
  },
  {
    "code": "CAD",
    "currency": "Canadian Dollar",
    "decimals": 2
  },
  {
    "code": "CHF",
    "currency": "Swiss Franc",
    "decimals": 2
  },
  {
    "code": "CLP",
    "currency": "Chilean Peso",
    "decimals": "2 (see note)"
  },
  {
    "code": "CNY",
    "currency": "Yuan Renminbi",
    "decimals": 2
  },
  {
    "code": "COP",
    "currency": "Colombian Peso",
    "decimals": 2
  },
  {
    "code": "CRC",
    "currency": "Costa Rican Colon",
    "decimals": 2
  },
  {
    "code": "CUP",
    "currency": "Cuban Peso",
    "decimals": 2
  },
  {
    "code": "CVE",
    "currency": "Cape Verdi Escudo",
    "decimals": "0 (see note)"
  },
  {
    "code": "CZK",
    "currency": "Czech Koruna",
    "decimals": 2
  },
  {
    "code": "DJF",
    "currency": "Djibouti Franc",
    "decimals": 0
  },
  {
    "code": "DKK",
    "currency": "Danish Krone",
    "decimals": 2
  },
  {
    "code": "DOP",
    "currency": "Dominican Republic Peso",
    "decimals": 2
  },
  {
    "code": "DZD",
    "currency": "Algerian Dinar",
    "decimals": 2
  },
  {
    "code": "EGP",
    "currency": "Egyptian Pound",
    "decimals": 2
  },
  {
    "code": "ETB",
    "currency": "Ethiopian Birr",
    "decimals": 2
  },
  {
    "code": "EUR",
    "currency": "Euro",
    "decimals": 2
  },
  {
    "code": "FJD",
    "currency": "Fiji Dollar",
    "decimals": 2
  },
  {
    "code": "FKP",
    "currency": "Falkland Islands Pound",
    "decimals": 2
  },
  {
    "code": "GBP",
    "currency": "Pound Sterling",
    "decimals": 2
  },
  {
    "code": "GEL",
    "currency": "Georgian Lari",
    "decimals": 2
  },
  {
    "code": "GHS",
    "currency": "Ghanaian Cedi (3rd)",
    "decimals": 2
  },
  {
    "code": "GIP",
    "currency": "Gibraltar Pound",
    "decimals": 2
  },
  {
    "code": "GMD",
    "currency": "Gambia Delasi",
    "decimals": 2
  },
  {
    "code": "GNF",
    "currency": "Guinea Franc",
    "decimals": 0
  },
  {
    "code": "GTQ",
    "currency": "Guatemala Quetzal",
    "decimals": 2
  },
  {
    "code": "GYD",
    "currency": "Guyanese Dollar",
    "decimals": 2
  },
  {
    "code": "HKD",
    "currency": "Hong Kong Dollar",
    "decimals": 2
  },
  {
    "code": "HNL",
    "currency": "Honduras Lempira",
    "decimals": 2
  },
  {
    "code": "HRK",
    "currency": "Croatia Kuna",
    "decimals": 2
  },
  {
    "code": "HTG",
    "currency": "Haitian Gourde",
    "decimals": 2
  },
  {
    "code": "HUF",
    "currency": "Hungarian Forint",
    "decimals": 2
  },
  {
    "code": "IDR",
    "currency": "Indonesian Rupiah",
    "decimals": "0 (see note)"
  },
  {
    "code": "ILS",
    "currency": "New Israeli Scheqel",
    "decimals": 2
  },
  {
    "code": "INR",
    "currency": "Indian Rupee",
    "decimals": 2
  },
  {
    "code": "IQD",
    "currency": "Iraqi Dinar",
    "decimals": 3
  },
  {
    "code": "ISK",
    "currency": "Iceland Krona",
    "decimals": "2 (see note)"
  },
  {
    "code": "JMD",
    "currency": "Jamaican Dollar",
    "decimals": 2
  },
  {
    "code": "JOD",
    "currency": "Jordanian Dinar",
    "decimals": 3
  },
  {
    "code": "JPY",
    "currency": "Japanese Yen",
    "decimals": 0
  },
  {
    "code": "KES",
    "currency": "Kenyan Shilling",
    "decimals": 2
  },
  {
    "code": "KGS",
    "currency": "Kyrgyzstan Som",
    "decimals": 2
  },
  {
    "code": "KHR",
    "currency": "Cambodia Riel",
    "decimals": 2
  },
  {
    "code": "KMF",
    "currency": "Comoro Franc",
    "decimals": 0
  },
  {
    "code": "KRW",
    "currency": "South-Korean Won",
    "decimals": 0
  },
  {
    "code": "KWD",
    "currency": "Kuwaiti Dinar",
    "decimals": 3
  },
  {
    "code": "KYD",
    "currency": "Cayman Islands Dollar",
    "decimals": 2
  },
  {
    "code": "KZT",
    "currency": "Kazakhstani Tenge",
    "decimals": 2
  },
  {
    "code": "LAK",
    "currency": "Laos Kip",
    "decimals": 2
  },
  {
    "code": "LBP",
    "currency": "Lebanese Pound",
    "decimals": 2
  },
  {
    "code": "LKR",
    "currency": "Sri Lanka Rupee",
    "decimals": 2
  },
  {
    "code": "LYD",
    "currency": "Libyan Dinar",
    "decimals": 3
  },
  {
    "code": "MAD",
    "currency": "Moroccan Dirham",
    "decimals": 2
  },
  {
    "code": "MDL",
    "currency": "Moldovia Leu",
    "decimals": 2
  },
  {
    "code": "MKD",
    "currency": "Macedonian Denar",
    "decimals": 2
  },
  {
    "code": "MMK",
    "currency": "Myanmar Kyat",
    "decimals": 2
  },
  {
    "code": "MNT",
    "currency": "Mongolia Tugrik",
    "decimals": 2
  },
  {
    "code": "MOP",
    "currency": "Macau Pataca",
    "decimals": 2
  },
  {
    "code": "MRU",
    "currency": "Mauritania Ouguiya",
    "decimals": 2
  },
  {
    "code": "MUR",
    "currency": "Mauritius Rupee",
    "decimals": 2
  },
  {
    "code": "MVR",
    "currency": "Maldives Rufiyaa",
    "decimals": 2
  },
  {
    "code": "MWK",
    "currency": "Malawi Kwacha",
    "decimals": 2
  },
  {
    "code": "MXN",
    "currency": "Mexican Peso",
    "decimals": 2
  },
  {
    "code": "MYR",
    "currency": "Malaysian Ringgit",
    "decimals": 2
  },
  {
    "code": "MZN",
    "currency": "Mozambican Metical",
    "decimals": 2
  },
  {
    "code": "NAD",
    "currency": "Namibian Dollar",
    "decimals": 2
  },
  {
    "code": "NGN",
    "currency": "Nigerian Naira",
    "decimals": 2
  },
  {
    "code": "NIO",
    "currency": "Nicaragua Cordoba Oro",
    "decimals": 2
  },
  {
    "code": "NOK",
    "currency": "Norwegian Krone",
    "decimals": 2
  },
  {
    "code": "NPR",
    "currency": "Nepalese Rupee",
    "decimals": 2
  },
  {
    "code": "NZD",
    "currency": "New Zealand Dollar",
    "decimals": 2
  },
  {
    "code": "OMR",
    "currency": "Rial Omani",
    "decimals": 3
  },
  {
    "code": "PAB",
    "currency": "Panamanian Balboa",
    "decimals": 2
  },
  {
    "code": "PEN",
    "currency": "Peruvian Nuevo Sol",
    "decimals": 2
  },
  {
    "code": "PGK",
    "currency": "New Guinea Kina",
    "decimals": 2
  },
  {
    "code": "PHP",
    "currency": "Philippine Peso",
    "decimals": 2
  },
  {
    "code": "PKR",
    "currency": "Pakistan Rupee",
    "decimals": 2
  },
  {
    "code": "PLN",
    "currency": "New Polish Zloty",
    "decimals": 2
  },
  {
    "code": "PYG",
    "currency": "Paraguay Guarani",
    "decimals": 0
  },
  {
    "code": "QAR",
    "currency": "Qatari Rial",
    "decimals": 2
  },
  {
    "code": "RON",
    "currency": "New Romanian Lei",
    "decimals": 2
  },
  {
    "code": "RSD",
    "currency": "Serbian Dinar",
    "decimals": 2
  },
  {
    "code": "RUB",
    "currency": "Russian Ruble",
    "decimals": 2
  },
  {
    "code": "RWF",
    "currency": "Rwanda Franc",
    "decimals": 0
  },
  {
    "code": "SAR",
    "currency": "Saudi Riyal",
    "decimals": 2
  },
  {
    "code": "SBD",
    "currency": "Solomon Island Dollar",
    "decimals": 2
  },
  {
    "code": "SCR",
    "currency": "Seychelles Rupee",
    "decimals": 2
  },
  {
    "code": "SEK",
    "currency": "Swedish Krone",
    "decimals": 2
  },
  {
    "code": "SGD",
    "currency": "Singapore Dollar",
    "decimals": 2
  },
  {
    "code": "SHP",
    "currency": "St. Helena Pound",
    "decimals": 2
  },
  {
    "code": "SLL",
    "currency": "Sierra Leone Leone",
    "decimals": 2
  },
  {
    "code": "SOS",
    "currency": "Somalia Shilling",
    "decimals": 2
  },
  {
    "code": "SRD",
    "currency": "Surinamese dollar",
    "decimals": 2
  },
  {
    "code": "STN",
    "currency": "Sao Tome & Principe Dobra",
    "decimals": 2
  },
  {
    "code": "SVC",
    "currency": "El Salvador Colón",
    "decimals": 2
  },
  {
    "code": "SZL",
    "currency": "Swaziland Lilangeni",
    "decimals": 2
  },
  {
    "code": "THB",
    "currency": "Thai Baht",
    "decimals": 2
  },
  {
    "code": "TND",
    "currency": "Tunisian Dinar",
    "decimals": 3
  },
  {
    "code": "TOP",
    "currency": "Tonga Pa'anga",
    "decimals": 2
  },
  {
    "code": "TRY",
    "currency": "New Turkish Lira",
    "decimals": 2
  },
  {
    "code": "TTD",
    "currency": "Trinidad & Tobago Dollar",
    "decimals": 2
  },
  {
    "code": "TWD",
    "currency": "New Taiwan Dollar",
    "decimals": 2
  },
  {
    "code": "TZS",
    "currency": "Tanzanian Shilling",
    "decimals": 2
  },
  {
    "code": "UAH",
    "currency": "Ukraine Hryvnia",
    "decimals": 2
  },
  {
    "code": "UGX",
    "currency": "Uganda Shilling",
    "decimals": 0
  },
  {
    "code": "USD",
    "currency": "US Dollars",
    "decimals": 2
  },
  {
    "code": "UYU",
    "currency": "Peso Uruguayo",
    "decimals": 2
  },
  {
    "code": "UZS",
    "currency": "Uzbekistani Som",
    "decimals": 2
  },
  {
    "code": "VEF",
    "currency": "Venezuelan Bolívar",
    "decimals": 2
  },
  {
    "code": "VND",
    "currency": "Vietnamese New Dong",
    "decimals": 0
  },
  {
    "code": "VUV",
    "currency": "Vanuatu Vatu",
    "decimals": 0
  },
  {
    "code": "WST",
    "currency": "Samoan Tala",
    "decimals": 2
  },
  {
    "code": "XAF",
    "currency": "CFA Franc BEAC",
    "decimals": 0
  },
  {
    "code": "XCD",
    "currency": "East Caribbean Dollar",
    "decimals": 2
  },
  {
    "code": "XOF",
    "currency": "CFA Franc BCEAO",
    "decimals": 0
  },
  {
    "code": "XPF",
    "currency": "CFP Franc",
    "decimals": 0
  },
  {
    "code": "YER",
    "currency": "Yemeni Rial",
    "decimals": 2
  },
  {
    "code": "ZAR",
    "currency": "South African Rand",
    "decimals": 2
  },
  {
    "code": "ZMW",
    "currency": "Zambian Kwacha",
    "decimals": 2
  }
]



// WEBPACK FOOTER //
// ./src/mixins/currency-codes-convert.js